import { Contact } from '@/app/network/models/contact';
import { BackLink } from '@/common/components/back-link';
import { Heading } from '@/common/components/heading';
import { Seo } from '@/common/components/seo';
import { ContactView } from '@/contacts/components/contact-view';
import { UpdateContact } from '@/contacts/components/update-contact';

type ShowContactsPageProps = {
  contactId: number;
  contact: Contact;
};

export function ShowContactsPage({ contact }: ShowContactsPageProps) {
  return (
    <>
      <Seo title={`${contact.firstName} ${contact.lastName}`} />
      <BackLink href="/contacts">
        Contacts
      </BackLink>
      <div className="flex items-center justify-between gap-4 mt-4">
        <Heading>{`${contact.firstName} ${contact.lastName}`}</Heading>
        <div className="flex gap-4">
          <UpdateContact contact={contact} />
        </div>
      </div>
      <div>
        <ContactView contact={contact} />
      </div>
    </>
  );
}
